import React from 'react';
import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';

/**
 * Component displaying reference tables for Lane Distribution Factor and Analysis Period
 * These tables provide guidance values for ESAL calculations
 */
const ReferenceTablesInfo: React.FC = () => {
    const { t } = useTranslation();

    return (
        <Box sx={{ display: 'flex', gap: 3, mb: 3 }}>
            {/* Table 1: Lane Distribution Factor */}
            <Box sx={{ flex: 1 }}>
                <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
                    {t('esal_lane_distribution_table_title', 'Lane Distribution Factor DL')}
                </Typography>
                <TableContainer component={Paper} variant="outlined" sx={{ maxHeight: 200 }}>
                    <Table size="small" stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ fontWeight: 'bold', backgroundColor: 'grey.100' }}>{t('esal_lanes_per_direction', 'Number of Lanes in Each Direction')}</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', backgroundColor: 'grey.100' }}>{t('esal_distribution_factor', 'DL')}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell>1</TableCell>
                                <TableCell>1.00</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>2</TableCell>
                                <TableCell>0.80 - 1.00</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>3</TableCell>
                                <TableCell>0.60 - 0.80</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>4</TableCell>
                                <TableCell>0.50 - 0.75</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>

            {/* Table 2: Analysis Period */}
            <Box sx={{ flex: 1 }}>
                <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
                    {t('esal_analysis_period_table_title', 'Analysis Period')}
                </Typography>
                <TableContainer component={Paper} variant="outlined" sx={{ maxHeight: 200 }}>
                    <Table size="small" stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ fontWeight: 'bold', backgroundColor: 'grey.100' }}>{t('esal_highway_condition', 'Highway Condition')}</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', backgroundColor: 'grey.100' }}>{t('esal_analysis_period_years', 'Analysis Period (years)')}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow>
                                <TableCell>{t('esal_high_volume_urban', 'High-Volume urban')}</TableCell>
                                <TableCell>30 - 50</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>{t('esal_high_volume_rural', 'High-Volume rural')}</TableCell>
                                <TableCell>20 - 50</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>{t('esal_low_volume_paved', 'Low-volume paved')}</TableCell>
                                <TableCell>15 - 25</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>{t('esal_low_volume_unpaved', 'Low-volume aggregate surface (unpaved)')}</TableCell>
                                <TableCell>10 - 20</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </Box>
    );
};

export default ReferenceTablesInfo;
